import Phaser from "phaser";
import { ShopItemSlot } from "@phaser/ui/shop/ShopItemSlot";
import type { ShopViewItem } from "@phaser/core/shop/shopTypes";

interface ShopSectionOptions {
  width: number;
  title: string;
  items: ShopViewItem[];
}

export class ShopSection extends Phaser.GameObjects.Container {
  public contentHeight = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: ShopSectionOptions,
  ) {
    super(scene, x, y);
    scene.add.existing(this);

    const itemWidth = 630;
    const itemHeight = 220;
    const rowGap = 16;

    const gridStartY = 10;
    const slotX = (options.width - itemWidth) / 2;

    // 아이템 슬롯 생성 및 세로 배치
    options.items.forEach((item, index) => {
      const slotY = gridStartY + index * (itemHeight + rowGap);

      const slot = new ShopItemSlot(scene, slotX, slotY, {
        width: itemWidth,
        height: itemHeight,
        item,
      });

      this.add(slot);
    });

    const rows = options.items.length;

    if (rows === 0) {
      this.contentHeight = gridStartY;
      return;
    }

    this.contentHeight = gridStartY + rows * itemHeight + (rows - 1) * rowGap;
  }
}
